import { takeEvery, take, put } from 'redux-saga/effects';
import { consts as submitReferralForm } from './submitReferralForm';

function* submitReferralFormWorker(action) {
  const { message } = action.payload;

  yield take(submitReferralForm.SUCCEED);
  yield put({
    type: submitReferralForm.MESSAGE,
    payload: message,
  });
}

export function* submitReferralFormSaga() {
  yield takeEvery(submitReferralForm.SEND, submitReferralFormWorker);
}



// WEBPACK FOOTER //
// ./src/redux/surveys/submitReferralFormSaga.js